export default {
  variants: {
    variant: {
      outline: 'text-white !bg-[rgba(0,0,0,30%)] ring ring-inset ring-(--ui-border-accented)',
      subtle: 'text-(--ui-text-dark) bg-white ring ring-inset ring-(--ui-border-accented)',
    },
    size: {
      xl: {
        base: 'pl-6 py-3',
      },
    },
  },
  slots: {
    root: 'w-full relative inline-flex items-center',
    trailingIcon: 'shrink-0 text-(--ui-text-dark)',
    base: 'w-full rounded-xl border-0 placeholder:text-(--ui-text-dimmed) focus:outline-none disabled:cursor-not-allowed disabled:opacity-75',
  },
};
